<syslink-modal #modal title="Translations" width="300px" (onValidate)="onTranslationModalValidate()">
    <div class="row gy-3">
        <div *ngFor="let translation of this.translations" class="col-12 d-flex justify-content-between align-items-center">
            <syslink-flag [flag]="translation.LanguageId.IsoCode === 'en' ? 'gb' : translation.LanguageId.IsoCode"></syslink-flag>
            <syslink-input-text class="w-100 ms-1" name="name-language-{{translation.LanguageId.Id}}" [label]="translation.LanguageId.Name" [(model)]="translation.Value"></syslink-input-text>
        </div>
    </div>
</syslink-modal>